import PropTypes from 'prop-types';
import React from 'react';

import CrossChannelActions from '../../../actions/CrossChannelActions';

import ModeToggle from './ModeToggle.react';

export default class ModeOptionSelect extends React.Component {
  constructor(props) {
    super(props);

    this.updateMode = CrossChannelActions.updateMode
      .bind(this, props.organizationId, props.mode.key);

    this.updateSelected = this.updateMode.bind(this, 'selected');
    this.updatePercentage = this.updateMode.bind(this, 'percentage');
    this.updatePercentageType = this.updateMode.bind(this, 'percentageType');

    this.onModeCheck = this.updateMode.bind(this, 'selected', true);
    this.onModeUncheck = () => {
      this.updateSelected(false);
      this.updatePercentage('');
      this.updatePercentageType('');
    };
  }

  render() {
    return (
      <div className='cca-mode-row col-md-3'>
        <ModeToggle
          selected={this.props.mode.selected}
          label={this.props.mode.displayLabel}
          onCheck={this.onModeCheck}
          onUncheck={this.onModeUncheck}
        />
      </div>
    );
  }
}

ModeOptionSelect.propTypes = {
  organizationId: PropTypes.number,
  mode: PropTypes.object,
};
